module.exports = __webpack_public_path__ + "img/email-selected.c85193e9.png";